import { studentConstants } from '../constants';

const initialState = {
    loading: false,
    studentslist: [],
    error: null
};

const studentReducer = (state = initialState, action) => {
    switch (action.type) {
        case studentConstants.FETCH_STUDENTSLIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case studentConstants.FETCH_STUDENTSLIST_SUCCESS:
            return {
                ...state,
                loading: false,
                studentslist: action.studentslist,
                error: null
            };
        case studentConstants.FETCH_STUDENTSLIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default studentReducer;
